import React from "react";
import "./VideoGallery.css";

function VideoItem(props) {
  var textoverimage = document.querySelectorAll(".video-desc div");
  for (var i = 0; i < textoverimage; i++) {
    textoverimage.onClick = function () {
      this.classList.toggle("show");
    };
  }
  return (
    <div
      className={
        !props.isservice
          ? "col-lg-3 col-md-3 col-sm-4 col-6 video position-relative"
          : "videowrapperdiv"
      }
    >
      <img src={props.data.thumbnail} alt="" className="img-fluid" />
      <button className="play-btn" onClick={props.onPlay}></button>
      {/* Hover feature on touch-device is not possible, so browser treats click as hover state initialized */}
      <div className="video-desc">
        <p id="vidgallery__paragraph">
          {props.data.description} -{props.data.date}
        </p>
      </div>
    </div>
  );
}

export default VideoItem;
